import { jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
const LabelOptional = ({
  optional,
  className,
  disabled,
  sx
}) => /* @__PURE__ */ jsx(Box, { height: 18, className, sx, children: optional && /* @__PURE__ */ jsx(
  Typography,
  {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    fontStyle: "italic",
    color: disabled ? "grey.400" : "grey.500",
    children: "(optional)"
  }
) });
export {
  LabelOptional
};
//# sourceMappingURL=LabelOptional.js.map
